__turbopack_context__.v({
  "animateAi": "ActionMessage-module__8nATRW__animateAi",
  "gradient-shift": "ActionMessage-module__8nATRW__gradient-shift",
});
